var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-container"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.image),expression:"image"}],staticClass:"share-img"})])}
var staticRenderFns = []

export { render, staticRenderFns }